module.exports = __webpack_public_path__ + "img/ba.a9dbadd7.svg";